import { HttpInterceptorFn } from '@angular/common/http';
import { isDevMode } from '@angular/core';
import { from } from 'rxjs';
import { mergeMap } from 'rxjs/operators';

const TRANSLATIONS_PREFIX = '/restful/translations/static-translation/';
const LOCAL_HEALTH_URL = 'http://localhost:5050/health';

let lastCheckAt = 0;
let lastUp: boolean | null = null;

export const translationsProxyRewriteInterceptor: HttpInterceptorFn = (req, next) => {
  if (!isDevMode()) {
    return next(req);
  }

  let url: URL;
  try {
    url = new URL(req.url);
  } catch {
    return next(req);
  }

  if (!url.pathname.startsWith(TRANSLATIONS_PREFIX)) {
    return next(req);
  }

  return from(isLocalServerUp()).pipe(
    mergeMap((up) => {
      if (!up) {
        return next(req);
      }

      const rewritten = `${url.pathname}${url.search}`;
      return next(req.clone({ url: rewritten }));
    }),
  );
};

async function isLocalServerUp(): Promise<boolean> {
  const now = Date.now();

  // cache for 2 seconds (tweak if you want)
  if (lastUp !== null && now - lastCheckAt < 2000) {
    return lastUp;
  }

  lastCheckAt = now;

  try {
    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), 250);

    await fetch(LOCAL_HEALTH_URL, {
      method: 'GET',
      mode: 'no-cors',
      cache: 'no-store',
      signal: controller.signal,
    });

    clearTimeout(timeout);
    lastUp = true;
    return true;
  } catch {
    lastUp = false;
    return false;
  }
}
